module.exports = __webpack_public_path__ + "img/americanfootball.3da74d32.svg";